import type { FC } from "react";
import { useOrderNotes } from "./useOrderNotes";
import { LinearProgress } from "@mui/material";
import NotesWithDate from "../../components/notes/NotesWithDate";

interface Props {
  readonly orderId: string;
  readonly contactDate: string | undefined;
}

const OrderNotes: FC<Props> = ({ orderId, contactDate }) => {
  const { notes, isLoading, addOrderNote } = useOrderNotes(orderId);
  return (
    <>
      {isLoading && <LinearProgress />}
      <NotesWithDate
        deleteDisabled
        notes={notes ?? []}
        contactDate={contactDate ?? null}
        onChange={async (notes, contactDate) => {
          await addOrderNote(notes[0].text, contactDate);
        }}
      />
    </>
  );
};

export default OrderNotes;
